// extracted by mini-css-extract-plugin
export var banner = "_3m-0";
export var icon = "_3m-1";
export var message = "_3m-2";